import React from 'react';
import { Row, Col } from 'react-bootstrap';

import InfoRow from 'components/common/InfoRow';

import { TIME_OPTION } from 'constants/time';

const MyPageViewMode = ({ me }) => {
  return (
    <Row>
      <Col md={6}>
        <InfoRow label="Name" value={me?.username} />

        <InfoRow label="Email" value={me?.email} />

        <InfoRow label="Phone Number" value={me?.phone} />
      </Col>

      <Col md={6}>
        <InfoRow
          label="Last Login"
          value={new Date(me?.last_login).toLocaleString('en-IN', TIME_OPTION)}
        />

        <InfoRow
          label="Updated Date"
          value={new Date(me?.modified).toLocaleString('en-IN', TIME_OPTION)}
        />

        <InfoRow
          label="Created Date"
          value={new Date(me?.created).toLocaleString('en-IN', TIME_OPTION)}
        />
      </Col>
    </Row>
  );
};

export default MyPageViewMode;
